import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ContactsInterface } from '@nebalkon-workspace/content-api';
import { NotModal } from '@nebalkon-workspace/ui-kit';
import { CabinetHelpContactsComponent } from './cabinet-help-contacts.component';

export interface CabinetHelpContactsModalData {
  contacts: ContactsInterface | null | undefined;
}

@Component({
  selector: 'lib-cabinet-help-contacts-modal',
  imports: [NotModal, CabinetHelpContactsComponent],
  templateUrl: './cabinet-help-contacts-modal.component.html',
  styleUrl: './cabinet-help-contacts-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinetHelpContactsModalComponent {
  readonly #data = inject<CabinetHelpContactsModalData>(DIALOG_DATA);

  protected readonly contacts = this.#data.contacts;
}
